import React from "react"
import { PointSystem } from "../models/leaderboards/PointSystem"
import { Tag } from 'antd'

export function matchTotal(matches: Array<any>) {
    const totalStats: Array<any> = []
    matches.forEach((match) => {
        if (match.matchname !== "Bonus") {
            var matchStats: Array<any> = JSON.parse(match.matchstats);
            matchStats.forEach((player) => {
                const playerName = player.name
                var index = totalStats.findIndex((stat: any) => stat.name === playerName)
                if (index === -1) {
                    totalStats.push({
                        ...player
                    })
                } else {
                    for (const property in totalStats[index]) {
                        if (property !== "name") {
                            totalStats[index][property] += player[property]
                        }
                    }
                }
            })
        }
    })
    return totalStats
}

export function calculatePointsPerMatch(matches: Array<any>, pointSystem: PointSystem): Map<string, Array<any>> {
    const tournamentPoints = new Map()

    matches.forEach((match) => {
        const matchPlacement = JSON.parse(match.placement)

        const matchPlacementStats: Array<any> = []
        matchPlacement.forEach((team: any) => {
            var placementPoint = 0
            const placement: Array<any> = pointSystem.placements.filter(placement => { return placement.placement === team.rank })
            if (placement.length === 1) {
                placementPoint = placement[0].points
            }
            const killPoints = (team.kills * pointSystem.kills)
            const totalPoints = killPoints + placementPoint
            matchPlacementStats.push({
                key: team.players,
                players: team.players.map((player: string) => { return <Tag key={match.matchid + player}>{player}</Tag> }),
                placement: team.rank,
                placementPoints: placementPoint,
                kills: team.kills,
                damage: team.damage,
                killPoints: killPoints,
                totalPoints: totalPoints
            })

            const teamPlayers = team.players.sort((a: any, b: any) => a.localeCompare(b)).join("|") // Order names alphabetically
            var exists = false;
            if (tournamentPoints.size === 0) {
                tournamentPoints.set(teamPlayers, [{
                    match: match.matchnumber,
                    points: totalPoints,
                    kills: team.kills,
                    damage: team.damage,
                    map: match.mapname
                }])
                exists = true;
            } else {
                if (tournamentPoints.get(teamPlayers) === undefined) {
                    tournamentPoints.forEach((value: Array<any>, key: string) => {
                        const keySplit = key.split("|")
                        if (keySplit.length !== team.players.length) {
                            if (keySplit.length < team.players.length) { // So current match has more players
                                if (team.players.includes(keySplit[0])) {
                                    console.debug("Current match has more players but matching player, so updating key to include everyone")
                                    const tempList = tournamentPoints.get(key)
                                    tempList.push({
                                        match: match.matchnumber,
                                        points: totalPoints,
                                        kills: team.kills,
                                        map: match.mapname
                                    })
                                    tournamentPoints.delete(key)
                                    tournamentPoints.set(teamPlayers, tempList)
                                    exists = true;
                                }
                            } else if (keySplit.length > team.players.length) { // So current match has less players
                                if (keySplit.includes(team.players[0])) {
                                    console.debug("Current match has less players but matching player, so grouping score here")
                                    tournamentPoints.get(key).push({
                                        match: match.matchnumber,
                                        points: totalPoints,
                                        kills: team.kills,
                                        map: match.mapname
                                    })
                                    exists = true;
                                }
                            }

                        }
                    })
                } else {
                    tournamentPoints.get(teamPlayers).push({
                        match: match.matchnumber,
                        points: totalPoints,
                        kills: team.kills,
                        damage: team.damage,
                        map: match.mapname
                    })
                    exists = true;
                }
            }

            if (!exists) {
                tournamentPoints.set(teamPlayers, [{
                    match: match.matchnumber,
                    points: totalPoints,
                    kills: team.kills,
                    damage: team.damage,
                    map: match.mapname
                }])
            }
        })
    })

    return tournamentPoints
}

export function leaderboardTotal(matchCount: number, tournamentPoints: Map<string, Array<any>>) {
    const totalPointsDataSource: Array<any> = []
    var activeMapList: Array<string> = []
    tournamentPoints.forEach((value: Array<any>, key: string) => {
        const tempMap = new Map()
        const mapPoints = new Map()
        var tempTotalPoints = 0
        var tempKills = 0
        var tempDamage = 0
        tempMap.set("key", key.split("|"))
        tempMap.set("players", key.split("|"))
        for (var i = 1; i <= matchCount; i++) {
            const matchNumber = i
            const match = value.find((match) => { return match.match === matchNumber })
            if (match === undefined) {
                tempMap.set(`match${i}`, 0)
            } else {
                tempMap.set(`match${match.match}`, match.points)
                // console.log(match)
                tempTotalPoints += match.points
                tempKills += match.kills
                tempDamage += parseFloat(match.damage)

                if (mapPoints.get(match.map) === undefined) {
                    mapPoints.set(match.map, match.points)
                } else {
                    mapPoints.set(match.map, mapPoints.get(match.map) + match.points)
                }
            }
        }
        tempMap.set("total", tempTotalPoints)
        tempMap.set("kills", tempKills)
        tempMap.set("damage", tempDamage)
        mapPoints.forEach((value: boolean, key: string) => {
            tempMap.set(key, value)
        });
        if (activeMapList.length === 0) {
            activeMapList = Object.keys(Object.fromEntries(mapPoints))
        }
        totalPointsDataSource.push(Object.fromEntries(tempMap))
    })

    return totalPointsDataSource.sort((a, b) => { return b.total - a.total || b.kills - a.kills || b.damage - a.damage })
}